import React, { useMemo } from 'react';

import type { ReferencesDict } from '@/api/mutations/useCreateManualThread';
import { TextWithReferences } from '@/helpers/formatReferences';

interface AnswerPreviewProps {
  answer: string;
  references: ReferencesDict;
}

const AnswerPreview: React.FC<AnswerPreviewProps> = ({ answer, references }) => {
  // Transform [1] format to [1]{uuid} format for display
  const formattedAnswer = useMemo(() => {
    if (!answer.trim()) return '';

    return answer.replace(/\[(\d+)\]/g, (match, num) => {
      const ref = references[num];
      if (ref?.id) {
        // Convert to [number]{uuid} format that TextWithReferences expects
        return `[${num}]{${ref.id}}`;
      }

      return match;
    });
  }, [answer, references]);

  return (
    <div className="flex h-full flex-col overflow-scroll">
      <div className="mb-2">
        <label className="text-sm font-semibold text-gray-700">Answer Preview</label>
      </div>
      <div className="prose prose-sm h-full max-w-full overflow-y-auto rounded-md border border-gray-200 bg-white p-4">
        {!answer.trim() ? (
          <p className="text-sm text-gray-400 italic">No answer text yet...</p>
        ) : (
          <TextWithReferences content={formattedAnswer} referencesDict={references} />
        )}
      </div>
    </div>
  );
};

export default AnswerPreview;
